export const initialApplication = {
    isMobile: isMobile,
    isRelease: isRelease,
    loginUrl: "",
    logoutUrl: "",
    isFetchingUserData: false,
    isFullScreenLoading: false,
    isAuthenticatedToView: true,
    isAuthorisedToView: true,
    isErrorView: false,
    isUnderMaintenanceView: false,
    underMaintenanceMessage: ""
};
